'use client'

import { HomepageTabModel } from 'types/models/homepage-blocks'

import useTabs from '../hooks/useTabs'
import Tabs from './Tabs'

type Props = {
  onTabClick?: (tabName: HomepageTabModel) => void
}

const HomeTabs = ({ onTabClick }: Props) => {
  const tabProps = useTabs()

  return <Tabs {...tabProps} onTabClick={onTabClick} />
}

export default HomeTabs
